import React from 'react';
import {connect} from 'react-redux';
import {getProfile} from '../../../actions/profileActions';

class Version extends React.Component {

	render() {
		if(this.props.profile !== null){
            return (
                <span className="text-lowercase">v{this.props.profile.version}</span>
            )
		} else {
			return null
		}
	}
}

const mapStateToProps = (state) => {
	return {
		profile : state.profileReducer.getProfile
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProfile : (object) => {
			dispatch(getProfile(object))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Version);